import { AttendanceConstants } from '../AttendanceConstants';
export var TicketStatusEnum;
(function (TicketStatusEnum) {
    TicketStatusEnum[TicketStatusEnum["None"] = 0] = "None";
    TicketStatusEnum["Waiting"] = "Waiting";
    TicketStatusEnum["Open"] = "Open";
    TicketStatusEnum["ClosedAttendant"] = "ClosedAttendant";
    TicketStatusEnum["ClosedClient"] = "ClosedClient";
    TicketStatusEnum["Transferred"] = "Transferred";
    TicketStatusEnum["Assigned"] = "Assigned";
})(TicketStatusEnum || (TicketStatusEnum = {}));
export class DashboardService {
    static $inject = ['MessagingHubService', 'AccountService2', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN'];
    constructor(MessagingHubService, AccountService2, MESSAGINGHUBDOMAIN, BLIP_DOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.AccountService2 = AccountService2;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
    }
    /**
     * Get number of tickets by status on current day for this bot
     */
    async getTicketsSummary(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/tickets', reportRequest),
            metadata: {
                'server.shouldStore': true,
            },
        });
    }
    /**
     * Get current day ticket metrics on this bot
     */
    async getTicketsMetricsSummary(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/ticket-metrics', reportRequest),
            metadata: {
                'server.shouldStore': 'true',
            },
        });
    }
    /**
     * Get current day attendant metrics on this bot
     */
    async getAttendantMetricsSummary(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/attendant-status-metrics', reportRequest),
            metadata: {
                'server.shouldStore': 'true',
            },
        });
    }
    /**
     * Get current day open tickets  on this bot
     */
    async getOpenTickets(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/open-tickets', reportRequest),
        });
    }
    /**
     * Get current day tickets on this bot
     */
    async getWaitingTickets(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/waiting-tickets', reportRequest),
        });
    }
    /**
     * Get current day attendants working on this bot
     */
    async getAttendants(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/attendants', reportRequest),
            metadata: {
                'server.shouldStore': true,
            },
        });
    }
    /**
     * Get attendants in active call on this bot
     */
    async getActiveCallsSession() {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/calls/active-sessions',
            metadata: {
                'server.shouldStore': true,
            },
        });
    }
    /**
     * Get current day teams working on this bot
     */
    async getTeams(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/teams', reportRequest),
        });
    }
    getTags(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/tags-metrics', reportRequest),
        });
    }
    /**
     * Check if an attendant is online.
     * @param application
     * @param identity
     */
    async getAttendantStatus(application, identity) {
        try {
            await this.MessagingHubService.sendCommand({
                method: 'get',
                uri: '/ping',
                to: identity,
            });
            return true;
        }
        catch (e) {
            return false;
        }
    }
    /**
     * Get information about certain ticket
     * @param application
     * @param ticketId - the ticket's ID
     */
    async getTicket(application, ticketId) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/ticket/${ticketId}`,
        });
    }
    /**
     * Get ticket information based on its parent's sequential ID
     * @param application
     * @param parentSequentialId - the ticket's ID
     */
    async getTicketByParentId(application, parentSequentialId) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/tickets/${parentSequentialId}/child`,
        });
    }
    /**
     * Get number of tickets by status for this bot
     * @param application
     * @param ticketId - the ticket's ID
     * @param team - the team to which the ticket will be transferred
     */
    async transferTicketToTeam(ticketId, team) {
        const me = await this.AccountService2.me();
        const closedBy = `${encodeURIComponent(me.email)}@${this.BLIP_DOMAIN}`;
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/tickets/${ticketId}/transfer`,
            type: 'application/vnd.iris.ticket+json',
            resource: {
                team,
                closedBy,
            },
        });
    }
    /**
     * Get number of tickets by status for this bot
     * @param application
     * @param ticketId - the ticket's ID
     * @param agent - the agent to which the ticket will be transferred
     */
    async transferTicketToAgent(ticketId, agent) {
        const me = await this.AccountService2.me();
        const closedBy = `${encodeURIComponent(me.email)}@${this.BLIP_DOMAIN}`;
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/tickets/${ticketId}/transfer`,
            type: 'application/vnd.iris.ticket+json',
            resource: {
                agentIdentity: agent,
                team: AttendanceConstants.DIRECT_TRANSFER_TEAM,
                closedBy,
            },
        });
    }
    /**
     * Get number of tickets by status for this bot
     * @param application
     * @param ticket - the ticket object
     */
    async closeTicket(ticket) {
        const me = await this.AccountService2.me();
        const closedBy = `${encodeURIComponent(me.email)}@${this.BLIP_DOMAIN}`;
        if (ticket.status === 'ClosedClient') {
            return await this.MessagingHubService.sendCommand({
                method: 'set',
                type: 'application/vnd.iris.ticket+json',
                to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
                uri: `/tickets/${ticket.id}/close`,
                resource: {
                    id: ticket.id,
                    tags: ticket.tags,
                    status: ticket.status,
                    ownerIdentity: ticket.ownerIdentity,
                    customerIdentity: ticket.customerIdentity,
                    firstResponseDate: ticket.firstResponseDate,
                    closedBy,
                },
            });
        }
        else {
            ticket.status = 'ClosedAttendant';
            return await this.MessagingHubService.sendCommand({
                method: 'set',
                to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
                uri: '/tickets/change-status',
                type: 'application/vnd.iris.ticket+json',
                resource: {
                    id: ticket.id,
                    tags: ticket.tags,
                    status: ticket.status,
                    ownerIdentity: ticket.ownerIdentity,
                    customerIdentity: ticket.customerIdentity,
                    firstResponseDate: ticket.firstResponseDate,
                    closedBy,
                },
            });
        }
    }
    async attendantDisconnect(attendantIdentity) {
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/attendant-disconnection-request-start',
            type: 'application/vnd.iris.desk.attendantdisconnectionrequeststart+json',
            resource: {
                attendantIdentity,
            },
        });
    }
    /**
     * Get number of tickets per hour on current day for this bot
     */
    async getTicketsPerHour(reportRequest) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/monitoring/tickets-per-hour', reportRequest),
        });
    }
    setUriParameters(baseUri, reportRequest) {
        let uri = baseUri + '?version=2';
        if (reportRequest.agentStatus && reportRequest.agentStatus.length > 0) {
            uri =
                uri +
                    `&agentStatus=${reportRequest.agentStatus.join(',')}`;
        }
        if (reportRequest.teams && reportRequest.teams.length > 0) {
            const teams = reportRequest.teams.map(t => t.replaceAll(AttendanceConstants.COMMA_CHAR, AttendanceConstants.COMMA_CHAR_ESCAPED));
            uri =
                uri +
                    `&teams=${encodeURIComponent(teams.join(','))}`;
        }
        if (reportRequest.agentIdentities && reportRequest.agentIdentities.length > 0) {
            uri =
                uri +
                    `&agentIdentities=${encodeURIComponent(reportRequest.agentIdentities.join(','))}`;
        }
        if (reportRequest.operators && reportRequest.operators.length > 0) {
            uri =
                uri +
                    `&operators=${encodeURIComponent(reportRequest.operators.join(','))}`;
        }
        if (reportRequest.customerIdentities?.length > 0) {
            uri = uri + `&customerIdentities=${encodeURIComponent(reportRequest.customerIdentities.join(','))}`;
        }
        if (reportRequest.take) {
            uri = `${uri}&$take=${reportRequest.take}&$skip=${reportRequest.skip}`;
        }
        if (reportRequest.refreshCache) {
            uri =
                uri +
                    `&refreshCache=${encodeURIComponent(reportRequest.refreshCache)}`;
        }
        if (reportRequest.searchTerm && reportRequest.searchTerm.value.length > 0) {
            const { name, value } = reportRequest.searchTerm;
            uri =
                uri +
                    `&${name}=${encodeURIComponent(value)}`;
        }
        return uri;
    }
}
DashboardService.$inject = ['MessagingHubService', 'AccountService2', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN'];
